import React from 'react'
import singtel from '../assets/singtel.png';    
import { Link } from 'react-scroll';
import { MdPersonAdd } from "react-icons/md";
 import { useState } from 'react';
 import { FaBars, FaTimes } from 'react-icons/fa';
import ConnectionForm from './ConnectionForm';

function Navbar({connection, setConnection}) {
    const [nav, setNav] = useState(false);
    
 
     
  return (
    <>
    <div className='w-screen fixed top-0 left-0 z-10'>
    <div className="flex justify-between items-center bg-gray-800 md:p-4 p-2 h-20  ">
        <div>
            <img src={singtel} alt="Singtel Logo" className="h-14 md:h-16 w-full" />
        </div>
        <div className="hidden md:flex items-center justify-between lg:gap-28 md:gap-10">
            <ul className="hidden md:flex justify-around items-center gap-4 text-lg font-inter">
                <li>
                    <Link to="home" className="text-white hover:text-gray-300 hover:cursor-pointer" offset={-80}>Home</Link>
                </li>
                <li>
                    <Link to="plans" className="text-white hover:text-gray-300 hover:cursor-pointer" offset={-80}>Plans</Link>
                </li>
                <li>
                    <Link to="services" className="text-white hover:text-gray-300 hover:cursor-pointer" offset={-80}>Services</Link>
                </li>
                <li>
                    <Link to="support" className="text-white hover:text-gray-300 hover:cursor-pointer" offset={-80}>Support</Link>
                </li>
            </ul>
            <div>
            <button className="bg-green-600 text-white rounded-lg mr-3 font-inter flex items-center p-2" onClick={()=>setConnection(!connection)}>                <MdPersonAdd className="mr-1" size={25}/>
                New Connection
            </button>
        </div>
        </div>
        <div className="md:hidden flex items-cetner">
            <button className=" text-white z-10" onClick={() => setNav(!nav)}>
                {nav ? <FaTimes size={25}/> :<FaBars size={25}/>}
            </button>
        </div>
        
    </div>
    <div className={nav ? "w-screen bg-gray-800 flex flex-row justify-between items-start " : "hidden"}>
            <ul className="flex flex-col gap-4 text-lg m-2 ml-3 justify-center items-start font-inter">
                <li>
                    <Link to="home" className="text-white hover:text-gray-300" offset={-80} onClick={()=>setNav(false)}>Home</Link>
                </li>
                <li>
                    <Link to="plans" className="text-white hover:text-gray-300" offset={-80} onClick={()=>setNav(false)}>Plans</Link>
                </li>
                <li>
                    <Link to="services" className="text-white hover:text-gray-300" offset={-80} onClick={()=>setNav(false)}>Services</Link>
                </li>
                <li>
                    <Link to="support" className="text-white hover:text-gray-300" offset={-80} onClick={()=>setNav(false)}>Support</Link>
                </li>
            </ul>
            <button className="bg-green-600 text-white rounded-lg mt-2 mr-3 font-inter" onClick={()=>setConnection(!connection)} ><Link to="/new-connection" className="flex items-center p-2">
                <MdPersonAdd className="mr-1" size={25}/>
                New Connection
            </Link> 
            </button>
            </div> 
   
    </div>
    {connection && <ConnectionForm setConnection={setConnection}/>}
 </> 
  )
}

export default Navbar